import actionTypes from './actionTypes';
import update from 'immutability-helper';
import { extractError } from 'src/utils/error';

export const initialState = {
  firstUncompletedModule: '',
  fundraiser: {},
  isEnrolled: false,
  isEnrolledIconHovered: false,
  isProgramStarted: false,
  program: {},
  programModules: [],
  progress: 0,
  showSummary: true,
  totalEnrolledUsers: 0,
  error: null,
};

export default function (state = initialState, action) {
  switch(action.type) {
    case actionTypes.ENROLL_FOR_PROGRAM_SUCCESS:
      return {
        ...state,
      };

    case actionTypes.UNENROLL_FROM_PROGRAM_SUCCESS:
      return {
        ...state,
        isEnrolled: false,
      };

    case actionTypes.FETCH_PROGRAM_DETAILS_SUCCESS:
      return {
        ...state,
        program: action.program,
        totalEnrolledUsers: action.totalEnrolledUsers,
        error: null,
      };

    case actionTypes.FETCH_PROGRAM_DETAILS_FAILURE:
      return {
        ...state,
        error: extractError(action.error),
      };

    case actionTypes.FETCH_PROGRAM_MODULES_UNENROLLED_SUCCESS: {
      return {
        ...state,
        programModules: action.programModules,
      };
    }

    case actionTypes.FETCH_PROGRAM_MODULES_ENROLLED_SUCCESS: {
      const firstOpenModule = action.programModules.find(m => m.sections && m.sections.find(x => !x.isCompleted));
      const isProgramStarted = !!action.programModules.find(m => m.sections && m.sections.find(x => x.isCompleted));
      const firstUncompletedModule =
        !!firstOpenModule
          ? firstOpenModule.code
          : isProgramStarted ? '' : action.programModules.find(m => m.sort === 1);

      const programModules = action.programModules.map(module => ({
        ...module,
        isOpen: !!firstOpenModule && firstOpenModule.sort === module.sort,
      }));

      return {
        ...state,
        programModules,
        progress: action.progress,
        firstUncompletedModule,
        isProgramStarted,
        isEnrolled: true,
      };
    }

    case actionTypes.FETCH_PROGRAM_OVERVIEW_FUNDRAISER_SUCCESS:
      return {
        ...state,
        fundraiser: action.fundraiser,
      };

    case actionTypes.TOGGLE_MODULE_OPEN_STATUS:
      const toggledModule = state.programModules.find(x => x.sort === action.moduleSort);
      return update(state, {
        programModules: {
          [state.programModules.indexOf(toggledModule)]: { $toggle: ['isOpen'] },
        },
      });

    case actionTypes.SHOW_PROGRAM_ABOUT:
      return {
        ...state,
        showSummary: false,
      };

    case actionTypes.TOGGLE_ENROLL_ICON_HOVER:
      return {
        ...state,
        isEnrolledIconHovered: action.isEnrolledIconHovered,
      };
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/modules/programs/overview/reducer.js